import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  root: { padding: theme.spacing(2), maxWidth: 800, margin: "0 auto" },
  stepper: { padding: theme.spacing(2, 0) },
  stepContent: { padding: theme.spacing(2, 0), minHeight: 320 },
  card: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    cursor: "pointer",
    "&:hover": { backgroundColor: theme.palette.action.hover }
  },
  cardSelected: { border: `2px solid ${theme.palette.primary.main}` },
  gridRow: { marginBottom: theme.spacing(2) },
  navButtons: { marginTop: theme.spacing(2), display: "flex", gap: theme.spacing(1), justifyContent: "space-between" },
  dayRow: { display: "flex", alignItems: "center", gap: theme.spacing(1), marginBottom: theme.spacing(1) },
  inlineRow: { display: "flex", alignItems: "center", gap: theme.spacing(1), marginBottom: theme.spacing(1), flexWrap: "wrap" },
  kanbanPreview: { padding: theme.spacing(1), backgroundColor: theme.palette.background.default, borderRadius: 4 },
  summaryList: { listStyle: "none", padding: 0, margin: 0 }
}));
